namespace GeniuzPOS.PosShift {
    export interface PaymentTypeRow {
        Id?: number;
        PaymentType?: number;
        PaymentName?: string;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        LastUpdate?: string;
    }

    export namespace PaymentTypeRow {
        export const idProperty = 'Id';
        export const nameProperty = 'PaymentName';
        export const localTextPrefix = 'PosShift.PaymentType';
        export const lookupKey = 'PosShift.PaymentType';

        export function getLookup(): Q.Lookup<PaymentTypeRow> {
            return Q.getLookup<PaymentTypeRow>('PosShift.PaymentType');
        }
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = '*';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            Id = "Id",
            PaymentType = "PaymentType",
            PaymentName = "PaymentName",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            LastUpdate = "LastUpdate"
        }
    }
}
